module.exports = __webpack_public_path__ + "img/cover.3914e81e.jpg";